import Indicator from "./Indicator";
import Icon from "../Icon";
import * as vars from "../../shared/variables";
import styled from "styled-components";
import {useState} from "react";
import {useMessages} from "../../hooks/useMessages";
import AccountMenu from "../AccountMenu";
import {useAtom} from "jotai";
import {nextSessionAtom} from "../../store/sessionAtom";
import {getTheme} from "../../shared/themeUtils";

const Account = styled.div`
    display: flex;
`

const AccountDrawer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
`

const Header = styled.div`
    border-bottom: 1px solid ${getTheme("colors.border")};
    padding: 0 10px 20px 0;
    color: ${getTheme("colors.primary")};
    font-weight: 500;
    display: flex;
    align-items: center;

    span {
        margin-left: 10px;
    }
`

const IndicatorAccount = () => {
  const [sessionAtom] = useAtom(nextSessionAtom)
  const {session, status} = sessionAtom
  const [indicatorTitle, setIndicatorTitle] = useState("")
  const messagesQuery = useMessages()

  const content = (
    <AccountDrawer>
      <Header>
        <Icon variant={"medium"} color={vars.primaryColor}>user-line</Icon>
        {messagesQuery.data && <span>{indicatorTitle}</span>}
      </Header>

      <AccountMenu className="mt-3"/>

    </AccountDrawer>
  )

  return (
    <Account>
      <Indicator placement={"end"} content={content} iconVariant={"medium"} img={"/icons/user.svg"}
                 accountText={session?.user?.fullname}/>
    </Account>
  )
}

export default IndicatorAccount;
